import { ACTIONS } from 'redux-api-call';
import { combineEpics, ofType } from 'redux-observable';
import { eq, flow, get } from 'lodash/fp';
import { filter, map } from 'rxjs/operators';

import { COMPLETE_SHIPPING_REQUEST_API_ID } from '../apiCalls/shippingRequests/complete';
import routerHistory from '../routerHistory';

const handleCompleteShippingRequestSuccess = actions$ =>
  actions$.pipe(
    ofType(ACTIONS.COMPLETE),
    filter(flow(get('payload.name'), eq(COMPLETE_SHIPPING_REQUEST_API_ID))),
    map(_ => {
      routerHistory.push(`/emarket/shipments?status=1001`);
    })
  );

export default combineEpics(handleCompleteShippingRequestSuccess);
